import '../scss/urgent-care-maps.scss';

class InjuryClinicLoader {
  constructor(gridSelector, templateSelector) {
    this.grid = document.querySelector(gridSelector);
    this.template = this.grid.querySelector(templateSelector);
    this.loader = this.createLoader();
    this.apiBase = '/wp-json/koc/v1/injury-clinics/';
  }

  createLoader() {
    const loader = document.createElement("p");
    loader.innerText = "Loading clinics...";
    loader.className = "clinic-loader";
    this.grid.appendChild(loader);
    return loader;
  }

  init() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        pos => this.fetchClinics(pos.coords.latitude, pos.coords.longitude),
        () => this.fetchClinics() // fallback
      );
    } else {
      this.fetchClinics();
    }
  }

  async fetchClinics(lat = null, lng = null) {
    try {
      const params = lat && lng ? `?latitude=${lat}&longitude=${lng}` : "";

      console.log(params); // Debugging line
      
      const response = await fetch(this.apiBase + params);
      const clinics = await response.json();
      
      console.log({clinics}); // Debugging line
      
      this.loader.remove();
      clinics.forEach(clinic => {
        const card = this.buildCard(clinic);
        this.grid.appendChild(card);
      });

      // remove the template card
      this.template.remove();
    } catch (err) {
      this.loader.innerText = "Failed to load clinics.";
      console.error(err);
    }
  }

  buildCard(clinic) {
    const card = this.template.cloneNode(true);
      card.classList.remove("urgent-care-template-card");
      card.classList.add("urgent-care-card");
 
    card.style.display = "block";

    // Title
    const titleEl = card.querySelector(".urgent-care-title .x-text-content-text-primary");
    if (titleEl) titleEl.innerText = clinic.display_title;

    // Address
    const addressEl = card.querySelector(".urgent-care-address .x-text-content-text-primary");
    let zipcodeRegex = /\d{5}(-\d{4})?$/;
    if (clinic.city) {
      clinic.city = clinic.city.replace(zipcodeRegex, '').trim();
    }
    if (addressEl) addressEl.innerHTML = `${clinic.address}<br>${clinic.city}`;

    // Hours
    const hoursEl = card.querySelector(".urgent-care .x-text-content-text-primary");
    if (hoursEl) hoursEl.innerHTML = clinic.hours;

    // Phone
    const phoneEl = card.querySelector(".urgent-care-phone-number .x-text-content-text-primary");
    if (phoneEl) phoneEl.innerText =  "(865) 252-5557";

    // Directions
    const directionsBtn = card.querySelector(".urgent-care-button");
    if (directionsBtn) directionsBtn.setAttribute("href", clinic.directions);

    // Image
    const imgEl = card.querySelector(".urgent-care-image img");
    if (imgEl && clinic.thumbnail_url) {
      imgEl.src = clinic.thumbnail_url;
      imgEl.alt = clinic.display_title || "Clinic image";
    }

    return card;
  }
}
document.addEventListener("DOMContentLoaded", () => {
  const loader = new InjuryClinicLoader(
    "#urgent-care-grid .x-row-inner", 
    ".urgent-care-template-card"
  );
  loader.init();
});